const apiProductType = [
  "PricingTool",
  "VarianceTable",
  "LucidComm",
  "Lookup",
  "RiskEngine",
  "PhoneScore",
  "QualityFields",
  "ClickBuy",
  "MiscData",
  "LucidInsights",
];


export default apiProductType;
